import { render, staticRenderFns } from "./SurveysTable.vue?vue&type=template&id=0c858234&scoped=true"
import script from "./SurveysTable.vue?vue&type=script&lang=ts"
export * from "./SurveysTable.vue?vue&type=script&lang=ts"
import style0 from "./SurveysTable.vue?vue&type=style&index=0&id=0c858234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c858234",
  null
  
)

export default component.exports